import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import echarts from 'echarts'
import ElementUI from 'element-ui' // element-ui
import 'element-ui/lib/theme-chalk/index.css' // element-ui样式
import '../src/assets/css/font-awesome-4.7.0/css/iconfont.css'
import '../src/assets/css/font-awesome-4.7.0/css/sidemenuicon.css'
import './assets/css/qweather/font/qweather-icons.css'
import i18n from '@/language/index' // 引入i18n
import ElementLocale from 'element-ui/lib/locale' // 引用element-ui
import './permission.js' // 页面设置
import VCharts from 'v-charts' // v-chart
import 'v-charts/lib/style.css' // v-chart样式
import '@/assets/css/font-awesome-4.7.0/css/font-awesome.min.css'
import permission from '@/directive/permission'
import * as filters from './filters' // global filter
import Pagination from '@/components/Pagination'
import Scroll from '@/components/Scroll'
import { parseTime, getMonthLength, deepClone, week } from '@utils'
import * as formatter from '@utils/element'

ElementLocale.i18n((key, value) => i18n.t(key, value)) // 实现element插件的多语言切换
Vue.use(ElementUI, { ElementLocale, size: 'medium' })

Vue.prototype.$echarts = echarts

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(VCharts)
Vue.use(permission)

Vue.config.productionTip = false

// 覆写element-ui $message
Vue.prototype.$message = function (msg) {
  ElementUI.Message({ ...msg, duration: 1000 })
}

// Vue全局方法
Object.keys(formatter).forEach(key => {
  Vue.prototype['$' + key] = formatter[key]
})

Vue.prototype.$parseTime = parseTime
Vue.prototype.$week = week
Vue.prototype.$gmt = getMonthLength
Vue.prototype.$deepClone = deepClone

Vue.prototype.$time = function (date, day) {
  const dd = new Date(date)
  return dd.setDate(dd.getDate() + day)
}

Vue.prototype.$msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'success' })
}

Vue.prototype.$msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'error' })
}

Vue.prototype.$msgInfo = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'info' })
}
Vue.prototype.$msgWarning = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'warning' })
}
// 事件总线
Vue.prototype.$bus = new Vue()

// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('Scroll', Scroll)
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')

